module.exports = __webpack_public_path__ + "assets/36.jpg?98a89f410bf09c54acc1e100ab25d03e";